export default function ZoneIndicator({ zone, heartRate, children }) {
  // 20% narrower than the parent — keeps the HR pulse halo + the metric stack
  // tighter on wide screens without changing internal padding.
  const WIDTH_CLASS = 'max-w-[80%] mx-auto';

  if (!zone) {
    return <div className={WIDTH_CLASS}>{children}</div>;
  }

  // Use the color from the zone object directly
  const color = zone.color || '#71717A';
  
  // Calculate pulse duration based on HR
  // Pulse rate = 1/3 of BPM
  // Duration = 60 / (HR / 3) = 180 / HR seconds
  // e.g., HR=150 -> pulse rate = 50/min -> duration = 1.2s
  // Default to 2s if no HR provided
  const pulseDuration = heartRate > 0 ? (180 / heartRate) : 2;
  
  // Clamp duration between 0.5s and 3s for reasonable animation
  const clampedDuration = Math.max(0.5, Math.min(3, pulseDuration));

  return (
    <div className={`relative ${WIDTH_CLASS}`}>
      <div
        className="absolute inset-0 rounded-xl pointer-events-none"
        style={{
          boxShadow: `0 0 0 20px ${color}`,
          opacity: 0.3,
          animation: `zone-pulse ${clampedDuration}s ease-in-out infinite`,
          zIndex: 0
        }}
      />
      <div className="relative z-10">
        {children}
      </div>
      <style>{`
        @keyframes zone-pulse {
          0%, 100% {
            opacity: 0.15;
            box-shadow: 0 0 0 12px ${color};
          }
          50% {
            opacity: 0.4;
            box-shadow: 0 0 0 20px ${color};
          }
        }
      `}</style>
    </div>
  );
}